import { render, staticRenderFns } from "./addTheme.vue?vue&type=template&id=489ae463&scoped=true&"
import script from "./addTheme.vue?vue&type=script&lang=js&"
export * from "./addTheme.vue?vue&type=script&lang=js&"
import style0 from "./addTheme.vue?vue&type=style&index=0&id=489ae463&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/_vue-loader@15.9.8@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "489ae463",
  null
  
)

export default component.exports